import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ACCOUNT_ACCESS_ERROR_EVENT } from '../pages/accountAccess';
import './AccountAccessNotice.css';

export default function AccountAccessNotice() {
  const location = useLocation();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleAccountAccessError = (event) => {
      setMessage(
        event?.detail?.message
        || 'Accounts could not be loaded. Please refresh this page and try again.'
      );
    };

    window.addEventListener(ACCOUNT_ACCESS_ERROR_EVENT, handleAccountAccessError);
    return () => window.removeEventListener(
      ACCOUNT_ACCESS_ERROR_EVENT,
      handleAccountAccessError
    );
  }, []);

  useEffect(() => {
    setMessage('');
  }, [location.pathname]);

  if (!message) return null;

  return (
    <div className="accountAccessNotice" role="alert">
      <div>
        <strong>Account information is unavailable.</strong>
        <span>{message}</span>
      </div>
      <button type="button" onClick={() => setMessage('')} aria-label="Dismiss account loading message">
        Dismiss
      </button>
    </div>
  );
}
